module.exports = __webpack_public_path__ + "media/images/emoticons/coldsweats02-0f298cb55d6d15de8ace88e7bb60f7e0.gif";